<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12.6195 6.73875C12.7223 6.73837 12.8208 6.77869 12.8925 6.8505C13.0386 6.99678 13.0354 7.23081 12.8854 7.37323L8.26878 11.6431C8.19717 11.714 8.09929 11.7538 7.99721 11.7535C7.8971 11.7524 7.80152 11.7127 7.73129 11.6431L3.11466 7.41691C3.03958 7.34564 2.99808 7.24721 3.00007 7.14503C3.00402 6.94092 3.1769 6.77859 3.38623 6.78244H5.71711C5.87334 6.78244 6 6.65892 6 6.50657L6 0.252014C2.54955 1.1401 0 4.2723 0 7.99998C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 7.99998C16 4.2723 13.4505 1.1401 10 0.252014V6.46288C10 6.61524 10.1267 6.73875 10.2829 6.73875H12.6195Z"
          fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconInvestBuy"
}
</script>

<style scoped>

</style>